import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '../shared/shared.module'
import { GeneralSearchResultComponent } from './general-search-result.component'
import { PipesModule } from '../../pipes/pipes.module'

@NgModule({
  declarations: [GeneralSearchResultComponent],
  imports: [CommonModule, SharedModule, PipesModule],
  exports: [GeneralSearchResultComponent],
})
export class GeneralSearchResultModule {}
